<div class="modal-content">
  <div class="modal-header justify-content-center">
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="nc-icon nc-simple-remove"></i>
    </button>
      <h5 class="title title-up">{{ title }}</h5>
  </div>
  <div class="modal-body">
      <div class="row">
          <div class="card card-plain">
              <div class="card-header" role="tab" id="headingOne">
                  <span data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Digite as informações abaixo para Solicitar o bem
                </span>
              </div>
              <div class="card-body">
                  <form [formGroup]="form">
                      <div class="row justify-content-center">

                          <div class="col-md-4 mx-auto">
                            <div class="form-group">
                                <label for="et_pt">Nr. Patrimonio</label>
                                <input type="text" class="form-control" id="et_pt" placeholder="Nr. Patrimonio" 
                                (blur)="onChange()"
                                formControlName="cD_BPM_NR_BEM_PATRIMONIAL"
                                [ngClass]="{
                                    'has-danger':
                                      form.controls.cD_BPM_NR_BEM_PATRIMONIAL.errors?.required &&
                                      form.controls.cD_BPM_NR_BEM_PATRIMONIAL.touched
                                  }">
                            </div>
                        </div>
                          <div class="col-md-4 mx-auto">
                            <div class="form-group">
                                <label for="desc">Descrição</label>
                                <textarea class="form-control" id="desc" placeholder="Descrição" rows="3"
                                [ngClass]="{
                                    'has-danger':
                                      form.controls.dS_BPM_DESCRICAO_BEM.errors?.required &&
                                      form.controls.dS_BPM_DESCRICAO_BEM.touched
                                  }"formControlName="dS_BPM_DESCRICAO_BEM"></textarea>
                            </div>
                        </div>
                          <div class="col-md-4">
                              <label for="">Nº de Série</label>
                              <div class="form-group">
                                  <input type="text" class="form-control text-center" formControlName="dS_BPM_NUMERO_SERIE">
                              </div>

                          </div>
                          <div class="col-md-4">
                              <label for="">Marca</label>
                              <div class="form-group">
                                  <input type="text" class="form-control text-center"  formControlName="dS_BPM_MARCA">
                              </div>

                          </div>
                          <div class="col-md-4">
                              <label for="">Modelo</label>
                              <div class="form-group">
                                  <input type="text" class="form-control text-center"  formControlName="dS_BPM_MODELO">
                              </div>

                          </div>
                          <div class="col-md-4">
                              <label for="">Outros</label>
                              <div class="form-group">
                                  <input type="text" class="form-control text-center"  formControlName="dS_BPM_OUTROS">
                              </div>

                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                                <label for="matricula_sol">Matricula do Solicitante</label>
                                <input type="number" class="form-control" placeholder="Matricula"
                                id="matricula_sol" formControlName="cD_CDU_MATRICULA_SOLICITACAO">
                            </div>
                          </div>
                          <!-- <div class="col-md-6">
                            <div class="form-group">
                                <label for="matricula_sol">Matricula do Solicitante</label>
                                    <ng-autocomplete 
                                    id="matricula_sol"
                                    [data]="data"
                                    [searchKeyword]="keywordMatricula"
                                    (selected)='selectDest($event)'
                                    [itemTemplate]="itemTemplateMatricula"
                                    [notFoundTemplate]="notFoundTemplate">                                 
                                  </ng-autocomplete>
                                  
                                  <ng-template #itemTemplateMatricula let-item>
                                    <a [innerHTML]="item.nome"></a>
                                  </ng-template>
                                  
                                  <ng-template #notFoundTemplate let-notFound>
                                  <div [innerHTML]="notFound"></div>
                                  </ng-template>
                                </div>

                        </div> -->
                      </div>
                  </form>
                  <div class="row">
                      <div class="col-md-12 text-center" *ngIf="loading">
                          <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div *ngIf="!loading" class="modal-footer">
      <div class="left-side">
          <button type="button" class="btn btn-danger btn-link" (click)="activeModal.close()">
            Cancelar
        </button>
      </div>
      <div class="divider"></div>
      <div class="right-side">
          <button type="button" class="btn btn-success btn-link" [disabled]="!form.valid" (click)="submit()">
            Solicitar
        </button>
      </div>
  </div>
</div>
